import { FocusEvent } from 'react';

import { useLocale } from './locale';

export function useNumberInput() {
  const { formatNumber, parseNumber } = useLocale();

  const onBlur = (event: FocusEvent<HTMLInputElement>) => {
    if (event.target.value) {
      const parsed = parseNumber(event.target.value);

      if (!isNaN(parsed)) {
        const min = parseInt(event.target.min) || 0;
        const max = parseInt(event.target.max) || 100000000;
        const newValue = Math.max(Math.min(parsed, max), min);

        event.target.value = formatNumber(newValue, { style: 'decimal', useGrouping: false });
      } else {
        event.target.value = '';
      }
    }
  };

  const format = (value: number) => {
    return formatNumber(value, { style: 'decimal', useGrouping: false });
  };

  const parse = (value: string) => {
    const parsed = parseNumber(value);

    return !isNaN(parsed) ? parsed : null;
  };

  return {
    handleNumberBlur: onBlur,
    formatNumber: format,
    parseNumber: parse,
  };
}
